// This file is generated automatically by scripts/generate-icon.js. Don't modify it.

import Clock from '../_raw/ui/icon_clock.svg';
import withIconProps from '../withIconProps';

export default withIconProps(Clock);
